// extracted by mini-css-extract-plugin
export var container = "ChampionshipOverview-module--container--f9005";
export var contentBox = "ChampionshipOverview-module--contentBox--9741b";
export var description = "ChampionshipOverview-module--description--b6a55";
export var overviewSection = "ChampionshipOverview-module--overviewSection--270a0";
export var subtitle = "ChampionshipOverview-module--subtitle--75407";
export var text = "ChampionshipOverview-module--text--877b9";
export var title = "ChampionshipOverview-module--title--a4a39";